import React from 'react';

import { IconButton, makeStyles } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

const resolveBackground = (theme, color) => {
  switch (color) {
    case 'white': {
      return theme.palette.common.white;
    }
    default: {
      return `linear-gradient(135deg, ${theme.palette.primary[50]} 0%, ${theme.palette.common.white} 48%, ${theme.palette.secondary[50]} 100%)`;
    }
  }
};

const useStyles = makeStyles(theme => ({
  header: {
    background: ({ background }) => resolveBackground(theme, background),
    minHeight: '132px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderBottomLeftRadius: theme.shape.borderRadiusLarge,
    borderBottomRightRadius: theme.shape.borderRadiusLarge,
    boxShadow: '0 18px 44px rgba(16, 24, 40, 0.08)',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      borderRadius: 0,
      minHeight: '112px',
    },
    padding: theme.spacing(0, 2),
    textAlign: 'center',
    position: 'relative',
    width: '100%',
    '&:before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      background: 'linear-gradient(90deg, rgba(255, 181, 90, 0.14), transparent 28%, rgba(104, 197, 248, 0.14) 72%, transparent)',
      pointerEvents: 'none',
    },
    '& > *': {
      position: 'relative',
      zIndex: 1,
    },
  },
  backButton: {
    position: 'absolute',
    left: theme.spacing(2),
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 1,
  },
}));

const Jumbotron = ({ children, className, background, showBackButton, onBack }) => {
  const styles = useStyles({ background });
  const history = useHistory();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      history.goBack();
    }
  };

  return (
    <header className={clsx(styles.header, className)}>
      {showBackButton && (
        <IconButton className={styles.backButton} onClick={handleBack} size='small'>
          <ArrowBack />
        </IconButton>
      )}
      {children}
    </header>
  );
};

Jumbotron.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  background: PropTypes.oneOf(['white', 'primary']),
  showBackButton: PropTypes.bool,
  onBack: PropTypes.func,
};

Jumbotron.defaultProps = {
  children: null,
  className: '',
  background: 'primary',
  showBackButton: false,
  onBack: undefined,
};

export default Jumbotron;
